import { SearchspringCollectionProvider } from '../fetchers/collection'

import { CarouselResults } from './CarouselResults'

export function CarouselCollection({ handle, itemClass, controlClass, toggleControls, productLimit }) {
  // Convert productLimit to number if it's a string (from HTML attribute)
  const limit = productLimit ? parseInt(productLimit, 10) : 20

  // Request extra products to account for potential indexing issues
  const adjustedLimit = limit + 3

  return (
    <SearchspringCollectionProvider handle={handle} resultsPerPage={adjustedLimit}>
      <CarouselResults
        className={itemClass}
        hideControlsOnMobile={true}
        controlClass={controlClass}
        toggleControls={toggleControls}
        maxResults={limit} // Pass the original limit to CarouselResults for display
      />
    </SearchspringCollectionProvider>
  )
}
